// import React, { useRef } from 'react';
// import Autoplay from "embla-carousel-autoplay";
// import { Carousel, CarouselContent, CarouselItem } from './ui/Carousel';
// import { useTranslation } from 'react-i18next';
// import { Helmet } from 'react-helmet-async';

// function Testimonials() {
//     const autoplay = useRef(Autoplay({ delay: 3000, stopOnInteraction: false })); // Autoplay every 3 seconds
//     const { t } = useTranslation();
//     const testimonials = t('testimonials.items', { returnObjects: true });

//     const handleMouseEnter = () => {
//         autoplay.current?.stop(); // Stop autoplay on hover
//     };

//     const handleMouseLeave = () => {
//         autoplay.current?.play(); // Resume autoplay when hover ends
//     };

//     return (
//         <div>
//             <Helmet>
//                 <meta name="description" content={t("meta.description")} />
//                 <meta name="keywords" content={t("meta.keywords")} />
//                 <meta name="author" content={t("meta.author")} />
//             </Helmet>
//             <p className="text-3xl text-center font-bold sm:py-20 md:py-20 lg:py-20 md:text-4xl lg:text-5xl">
//                 {t('testimonials.title')}
//             </p>
//             <div
//                 className="flex justify-center items-center md:px-12 lg:px-16"
//                 onMouseEnter={handleMouseEnter}
//                 onMouseLeave={handleMouseLeave}
//             >
//                 <Carousel
//                     plugins={[autoplay.current]}
//                     className="sm:max-w-full lg:max-w-full lg:px-8 rounded-lg"
//                 >
//                     <CarouselContent className="flex">
//                         {testimonials.map((testimonial, index) => (
//                             <CarouselItem key={index} className="flex-none xs:w-full sm:w-full lg:w-1/3 sm:px-8  lg:px-4 ">
//                                 <div className="flex flex-col h-full bg-transparent text-white border-2 border-[#5ecaf4] rounded-sm">
//                                     <div className="flex-grow px-4">
//                                         <p className="mt-4 text-left">{testimonial.description}</p>
//                                     </div>

//                                     <div className='flex'>
//                                         <div className="px-4 py-4 mt-auto">
//                                             <h3 className="text-xl font-bold">{testimonial.image}</h3>

//                                         </div>
//                                         <div className="px-4 py-4 mt-auto">
//                                             <h3 className="text-xl font-bold">{testimonial.name}</h3>
//                                             <p className="text-md">{testimonial.designation}</p>
//                                         </div>

//                                     </div>

//                                 </div>
//                             </CarouselItem>
//                         ))}
//                     </CarouselContent>
//                 </Carousel>
//             </div>
//         </div>
//     );
// }

// export default Testimonials;


// Testimonials.jsx
import React, { useRef } from 'react';
import Autoplay from "embla-carousel-autoplay";
import { Carousel, CarouselContent, CarouselItem } from './ui/Carousel';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import TestimonialCard from './TestmonialCard';

function Testimonials() {
    const autoplay = useRef(Autoplay({ delay: 4000, stopOnInteraction: true }));
    const { t } = useTranslation();
    
    // Enhanced testimonials with proper structure
    const testimonials = [
{
    id: 1, 
    name: "Sarah Johnson",
    role: "CEO, TechStart London",
    description: "Wasif delivered our MVP in just 6 weeks. His technical leadership and React expertise helped us secure our first round of funding. Exceptional work!",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    rating: 5
},
        {
            id: 2, 
            name: "Michael Chen",
            role: "Product Manager, NYC Startup",
            description: "The AI integration Wasif implemented transformed our product. His solution architecture skills are outstanding. Highly recommended for complex projects.",
            image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
            rating: 5
        },
        {
            id: 3, // ADD UNIQUE ID FOR KEY PROP
            name: "Emma Davis",
            role: "Founder, Manchester FinTech",
            description: "30+ MVPs delivered is no exaggeration. Wasif's team leadership and Node.js expertise helped us scale rapidly. A true technical partner.",
            image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
            rating: 5
        },
        {
            id: 4, // ADD UNIQUE ID FOR KEY PROP
            name: "James Wilson",
            role: "CTO, San Francisco SaaS",
            description: "Outstanding Python development and cloud architecture. Wasif delivered a scalable solution that handles our growing user base perfectly.",
            image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
            rating: 5
        },
        {
            id: 5, // ADD UNIQUE ID FOR KEY PROP
            name: "Lisa Martinez",
            role: "Director, Berlin Startup",
            description: "Working with Wasif was a game-changer. His full-stack expertise and attention to detail resulted in a flawless product launch.",
            image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face",
            rating: 5
        }
    ];

    const handleMouseEnter = () => {
        autoplay.current?.stop();
    };

    const handleMouseLeave = () => {
        autoplay.current?.play();
    };

    return (
        <section id="testimonials" className="py-20">
            {/* Enhanced SEO Meta Tags */}
            <Helmet>
                <title>Client Testimonials | Team Lead & MVP Specialist - Wasif Shehzad</title>
                <meta name="description" content="Read client testimonials for Wasif Shehzad - Team Lead & Solution Architect with 30+ MVP deliveries. UK & USA startup success stories." />
                <meta name="keywords" content="client testimonials, MVP developer reviews, team lead feedback, solution architect recommendations, UK startup success" />
                
                {/* Structured Data for Testimonials */}
                <script type="application/ld+json">
                    {`
                    {
                        "@context": "https://schema.org",
                        "@type": "ItemList",
                        "name": "Client Testimonials",
                        "description": "Client reviews and testimonials for Wasif Shehzad - Team Lead & Solution Architect",
                        "itemListElement": [
                            {
                                "@type": "ListItem",
                                "position": 1,
                                "item": {
                                    "@type": "Review",
                                    "author": {
                                        "@type": "Person",
                                        "name": "Sarah Johnson"
                                    },
                                    "reviewBody": "Wasif delivered our MVP in just 6 weeks. His technical leadership and React expertise helped us secure our first round of funding. Exceptional work!",
                                    "reviewRating": {
                                        "@type": "Rating",
                                        "ratingValue": "5"
                                    }
                                }
                            },
                            {
                                "@type": "ListItem",
                                "position": 2,
                                "item": {
                                    "@type": "Review",
                                    "author": {
                                        "@type": "Person",
                                        "name": "Michael Chen"
                                    },
                                    "reviewBody": "The AI integration Wasif implemented transformed our product. His solution architecture skills are outstanding. Highly recommended for complex projects.",
                                    "reviewRating": {
                                        "@type": "Rating",
                                        "ratingValue": "5"
                                    }
                                }
                            }
                        ]
                    }
                    `}
                </script>
            </Helmet>

            {/* Section Header */}
            <div className="text-center mb-16">
                <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
                    Client Success Stories
                </h2>
                <p className="text-xl text-[#5ecaf4] max-w-2xl mx-auto">
                    Don't just take our word for it. Here's what our clients say about working with us.
                </p>
            </div>

            {/* Testimonials Carousel */}
            <div
                className="px-4 md:px-8 lg:px-16"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <Carousel
                    plugins={[autoplay.current]}
                    opts={{
                        align: "start",
                        loop: true,
                    }}
                    className="w-full"
                >
                    <CarouselContent className="-ml-2 md:-ml-4">
                        {testimonials.map((testimonial) => (
                            <CarouselItem 
                                key={testimonial.id} 
                                className="pl-2 md:pl-4 lg:basis-1/2 xl:basis-1/3"
                            >
                                <div className="p-2 h-full">
                                    <TestimonialCard 
                                        name={testimonial.name}
                                        role={testimonial.role}
                                        description={testimonial.description}
                                        image={testimonial.image}
                                        rating={testimonial.rating}
                                    />
                                </div>
                            </CarouselItem>
                        ))}
                    </CarouselContent>
                </Carousel>
            </div>

            {/* Trust Indicators */}
            <div className="text-center mt-16">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
                    <div className="text-white">
                        <div className="text-3xl font-bold text-[#5ecaf4]">50+</div>
                        <div className="text-sm">MVPs Delivered</div>
                    </div>
                    <div className="text-white">
                        <div className="text-3xl font-bold text-[#5ecaf4]">100%</div>
                        <div className="text-sm">Client Satisfaction</div>
                    </div>
                    <div className="text-white">
                        <div className="text-3xl font-bold text-[#5ecaf4]">4-8</div>
                        <div className="text-sm">Week Delivery</div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Testimonials;